module.exports = __webpack_public_path__ + "static/gbg-tech-week-184af3e46587ffb7c7156f75c005a814.png";